<div *ngIf="!loading" class="chartHost" fxFlex fxLayout="row" fxLayoutAlign="center center"
    [class.is-empty]="!hasPopulatedData">
    <div class="parentGraph">
        <mat-icon class="customDownload" *ngIf="customDownload.type && hasChartData"
            (click)="downloadDataMethod(customDownload.type)" title="{{customDownload['title'] }}">download</mat-icon>
        <div class="chartLayer">
            <!-- [ngStyle]="{'height' : chartHeight}" -->
            <apx-chart *ngIf="isViewInitialized && hasChartData" style="width: 100%;display: block;" [series]="chartSeries" [chart]="chartDetails"
                [xaxis]="xaxis" [dataLabels]="dataLabels" [title]="title" [labels]="labels" [colors]="colors"
                [tooltip]="tooltip" [plotOptions]="plotOptions" [legend]="legend">
            </apx-chart>
        </div>
        <div class="noDataOverlay" *ngIf="!hasPopulatedData">
            <span class="noDataOverlayText">There is no data to populate this graph</span>
        </div>
    </div>
</div>
